import { Button, Modal, Spin, Row, Col, Checkbox, Card, Image, message } from 'antd'
import React, { useState } from 'react'
import axios from 'axios'
import { BorderOutlined, CheckSquareOutlined, DeleteOutlined, FilePdfOutlined } from '@ant-design/icons';
import { baseUrlUPLOADIMAGELAWYER, DELETE_GATHER_IMAGE, GET_GATHER_IMAGE, HEADERS_BASIC } from '../../../API/apiUrlsNew';

function DeleteImage({ open, close, data, setData, handleUpdate }) {

    const token = localStorage.getItem('TOKEN');
    const [loading, setLoading] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);

    const handleClose = () => {
        close(false)
    }

    // ✅ ฟังก์ชันเลือก/ยกเลิกเลือก
    const handleSelectImage = (imageData) => {
        setSelectedImages((prevSelected) => {
            const isSelected = prevSelected.some((img) => img.path === imageData.path);
            return isSelected
                ? prevSelected.filter((img) => img.path !== imageData.path)
                : [...prevSelected, imageData];
        });
    };

    // ✅ เลือกทั้งหมด
    const handleSelectAll = () => {
        setSelectedImages(data);
    };

    // ✅ ยกเลิกทั้งหมด
    const handleDeselectAll = () => {
        setSelectedImages([]);
    };

    // ✅ ลบรายการที่ถูกเลือก
    const handleDeleteSelected = () => {
        handleDeleteIMG(selectedImages)
        setSelectedImages([]); // เคลียร์ค่าหลังลบ
    };


    const handleDeleteIMG = async (value) => {
        setLoading(true)
        if (value.length > 0) {
            axios.delete(baseUrlUPLOADIMAGELAWYER + DELETE_GATHER_IMAGE, { data: value }, { headers: HEADERS_BASIC })
                .then((res) => {
                    if (res.status === 200) {
                        const selectedIds = new Set(value.map(img => img.path));
                        const updatedDataDeteleIMG = data.filter(img => !selectedIds.has(img.path));
                        setData(updatedDataDeteleIMG);
                        message.success("ลบรูปสำเร็จ");
                        if (updatedDataDeteleIMG.length === 0) {
                            handleUpdate("deleteAll")
                        }
                    }
                })
                .catch(err => {
                    message.error("เกิดข้อผิดพลาด ลบรูปไม่สำเร็จ");
                    console.error("err", err)
                })
                .finally(() => setLoading(false));
        }
    }

    return (
        <Modal
            title="หน้าต่างลบรูปภาพ"
            open={open}
            onCancel={handleClose}
            footer={
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '8px' }}>
                    <Button
                        key="close"
                        type="primary"
                        style={{ backgroundColor: 'gray', flex: '1 1 auto', minWidth: '150px' }}
                        onClick={handleClose}
                    >
                        ปิด
                    </Button>
                    <Button
                        type='primary'
                        key="selectAll"
                        icon={<CheckSquareOutlined />}
                        onClick={handleSelectAll}
                        disabled={selectedImages.length === data.length}
                        style={{ flex: '1 1 auto', minWidth: '150px' }}
                    >
                        เลือกทั้งหมด
                    </Button>
                    <Button
                        type='primary'
                        key="deselectAll"
                        icon={<BorderOutlined />}
                        onClick={handleDeselectAll}
                        disabled={selectedImages.length === 0}
                        style={{ flex: '1 1 auto', minWidth: '150px' }}
                    >
                        ยกเลิกที่เลือก
                    </Button>
                    <Button
                        key="delete"
                        type="primary"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={handleDeleteSelected}
                        disabled={selectedImages.length === 0}
                        style={{ flex: '1 1 auto', minWidth: '150px' }}
                    // style={{ flex: '1 1 auto', minWidth: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        ลบที่เลือก
                        ({selectedImages.length})
                    </Button>
                </div>
            }
        >
            <Spin spinning={loading} size="large" tip="Loading...">
                <Row gutter={[8, 8]} justify="center">
                    {data?.map((e, index) => {
                        const isPdf = e.path?.toLowerCase().endsWith('.pdf');
                        return (
                            <Col key={index} xs={12} sm={8} md={6} lg={6} xl={6}>
                                <div style={{ position: 'relative', width: '100%', textAlign: 'center' }}>
                                    <Checkbox
                                        checked={selectedImages.some((img) => img.path === e.path)}
                                        onChange={() => handleSelectImage(e)}
                                        style={{
                                            position: 'absolute',
                                            top: 8,
                                            left: 8,
                                            zIndex: 10,
                                            backgroundColor: 'white',
                                            padding: '4px',
                                            borderRadius: '4px'
                                        }}
                                    />
                                    <Card hoverable style={{ width: '100%', textAlign: 'center' }} bodyStyle={{ padding: '8px' }}>
                                        {isPdf ?
                                            <div
                                                onClick={() => window.open(`${GET_GATHER_IMAGE}/${e.path}?token=${token}`, '_blank')}
                                                style={{
                                                    height: '120px',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#f0f0f0',
                                                    borderRadius: '8px',
                                                    border: '1px solid #d9d9d9'
                                                }}
                                            >
                                                <FilePdfOutlined style={{ fontSize: '40px', color: '#ff4d4f' }} />
                                                <span style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                                                    คลิกเพื่อเปิด PDF
                                                </span>
                                            </div>
                                            :
                                            <Image
                                                width="100%"
                                                height="120px"
                                                src={`${GET_GATHER_IMAGE}/${e.path}?token=${token}`}
                                                alt={`รูปภาพ ${index}`}
                                                style={{ objectFit: 'cover', borderRadius: '8px' }}
                                            />
                                        }
                                    </Card>
                                </div>
                            </Col>
                        )
                    })}

                </Row>
            </Spin>
        </Modal>

    )
}

export default DeleteImage